var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 0H8.55C4.98775 0 3.20663 0 1.95802 0.907169C1.55477 1.20015 1.20015 1.55477 0.907169 1.95802C0 3.20663 0 4.98776 0 8.55V13.5417C0 13.6577 0 13.7158 0.00101451 13.7648C0.0536529 16.3113 2.10538 18.363 4.65183 18.4157C4.70091 18.4167 4.75894 18.4167 4.875 18.4167H14.625C14.7411 18.4167 14.7991 18.4167 14.8482 18.4157C17.3946 18.363 19.4463 16.3113 19.499 13.7648C19.5 13.7158 19.5 13.6577 19.5 13.5417V8.55C19.5 4.98775 19.5 3.20663 18.5928 1.95802C18.2999 1.55477 17.9452 1.20015 17.542 0.907169C16.2934 0 14.5122 0 10.95 0Z",
    fill: "#EAF8ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17047 10.0044L1.79258 12.5441C1.60057 12.898 1.5 13.2942 1.5 13.6969C1.5 15.477 2.94305 16.92 4.72314 16.92H14.9912C16.6529 16.92 18 15.5729 18 13.9112C18 13.3767 17.8103 12.8596 17.4646 12.4519L16.408 11.2056C16.1602 10.9133 16.0362 10.7671 15.9153 10.6635C15.2194 10.0668 14.2069 10.0198 13.4585 10.5492C13.3286 10.6412 13.1916 10.7752 12.9177 11.0433C12.6106 11.3439 12.4571 11.4942 12.3157 11.5916C11.4972 12.1557 10.3885 12.0329 9.71316 11.3034C9.59655 11.1775 9.4796 10.9973 9.24571 10.6368L9.2457 10.6368L8.69451 9.78744C7.71636 8.28012 7.22728 7.52647 6.62008 7.29349C6.10809 7.09703 5.53789 7.11943 5.04289 7.35544C4.45583 7.63533 4.02738 8.42503 3.17047 10.0044Z",
    fill: "#2EBB49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.5C16.5 6.88071 15.3807 8 14 8C12.6193 8 11.5 6.88071 11.5 5.5C11.5 4.11929 12.6193 3 14 3C15.3807 3 16.5 4.11929 16.5 5.5Z",
    fill: "#2EBB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.becf2be130b38ddb25c2be52681aae00.svg";
export { ForwardRef as ReactComponent };